import { apiFetch } from './api';
import { useAuthStore } from '../store/useAuthStore';

// Company profile API client (SaaS hardening). Mirrors the backend contract in
// backend/src/routes/companyProfile.ts: GET is available to any authenticated
// user (the sidebar needs the brand name), PUT is ADMIN-only.

export interface CompanyProfile {
  id: string;
  legalName: string;
  displayName: string | null;
  cui: string | null;
  regCom: string | null;
  address: string | null;
  city: string | null;
  county: string | null;
  country: string;
  iban: string | null;
  bank: string | null;
  email: string | null;
  phone: string | null;
  website: string | null;
  logoUrl: string | null;
  defaultCurrency: string;
  vatPayer: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CompanyProfileInput {
  legalName: string;
  displayName?: string | null;
  cui?: string | null;
  regCom?: string | null;
  address?: string | null;
  city?: string | null;
  county?: string | null;
  country?: string | null;
  iban?: string | null;
  bank?: string | null;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  defaultCurrency?: 'RON' | 'EUR' | 'USD';
  vatPayer?: boolean;
}

interface Envelope<T> {
  success: true;
  data: T;
}

function authHeaders(): Record<string, string> {
  const token = useAuthStore.getState().accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** `profile: null` = the company profile was never filled in (wizard step). */
export async function getCompanyProfile(): Promise<CompanyProfile | null> {
  const res = await apiFetch<Envelope<{ profile: CompanyProfile | null }>>('/api/company-profile', {
    headers: authHeaders(),
  });
  return res.data.profile;
}

export async function saveCompanyProfile(input: CompanyProfileInput): Promise<CompanyProfile> {
  const res = await apiFetch<Envelope<{ profile: CompanyProfile }>>('/api/company-profile', {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(input),
  });
  return res.data.profile;
}
